module.exports = __webpack_public_path__ + "img/cloud.9c5e4d0b.png";